export const MINIMAL_API_PROMISE_RESOLVE_TIME = 1000; // 1 second

export const ExternalLinks = {
  LearningCenter:
    'https://gaf.docebosaas.com/openportal/pages/39/welcome-to-the-gaf-energy-learning-portal',
  TypeForm: 'https://gafenergy.typeform.com/to/wmksTM',
  MarketingMaterials: 'https://www.gaf.energy/materials/',
};
